import { Outlet } from 'react-router-dom';
import Navbar from '@/components/navbar/navbar';
import { useDoctorStatus } from '@/hooks/useDoctorStatus';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { useTranslation } from 'react-i18next';

export function DashboardLayout() {
  const doctor = useDoctorStatus();
  const { t } = useTranslation('doctor-platform');
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1 pt-14 lg:pl-64">
        <div className="container mx-auto px-4 py-8 space-y-4">
          {!doctor.loading && doctor.hasProfile && !doctor.prescribingEnabled && (
            <Alert>
              <AlertTitle>{t('layout.pendingApproval.title')}</AlertTitle>
              <AlertDescription>
                {t('layout.pendingApproval.description')}
              </AlertDescription>
            </Alert>
          )}
          <Outlet />
        </div>
      </main>
    </div>
  );
}

export default DashboardLayout;

